import * as React from 'react';
import {styled} from '../../utils';
import {LayoutProps, LayoutState, LayoutHooks} from './types';

const Root = styled('div')<LayoutProps>(({hasSider}) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: hasSider ? 'row' : 'column',
  flex: 1,
  flexBasis: 'auto',
  minHeight: 0
}));

const LayoutHookContext = React.createContext<LayoutHooks>({});

// TODO: add docs
class Layout extends React.Component<LayoutProps, LayoutState> {
  constructor(props: LayoutProps) {
    super(props);
    this.state = {siders: []};
  }

  public render() {
    const {children, hasSider, ...restProps} = this.props;
    return (
      <Root {...restProps} hasSider={hasSider || this.state.siders.length > 0}>
        <LayoutHookContext.Provider
          value={{
            registerSider: this._registerSider,
            unregisterSider: this._unregisterSider
          }}
        >
          {children}
        </LayoutHookContext.Provider>
      </Root>
    );
  }

  private _registerSider = (id: string) => {
    this.setState(({siders}) => ({
      siders: [...siders, id]
    }));
  };

  private _unregisterSider = (id: string) => {
    this.setState(({siders}) => ({siders: siders.filter(currentId => currentId !== id)}));
  };
}

export default Layout;

export const LayoutHookContextConsumer = LayoutHookContext.Consumer;



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.tsx